/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import { app } from '../../reducers/app';

interface NotificationSnackbarProps {
  style?: React.CSSProperties;
}

export const NotificationSnackbar: React.FC<NotificationSnackbarProps> = (
  props,
) => {
  const dispatch = useDispatch();
  const appState = useSelector((state: RootState) => state.app);

  const handleClose = () => {
    dispatch(app.actions.closeGlobalMessage());
  };

  return (
    <Snackbar
      open={appState.globalMessageOpen}
      autoHideDuration={3000}
      onClose={handleClose}
      style={props.style}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert
        onClose={handleClose}
        severity={appState.globalMessageStatus}
        sx={{ width: '100%' }}
      >
        {appState.globalMessage}
      </Alert>
    </Snackbar>
  );
};
